import styles from './NossosValores.module.css';
import ParticlesBackground from '../../components/ParticlesBackground/ParticlesBackground';
import { motion } from 'framer-motion';
import {
  FaMagnifyingGlass, FaLightbulb, FaHandshake,
  FaShield, FaStar, FaSeedling,
} from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';
import PageSEO from '../../components/PageSEO/PageSEO';

const reveal = (delay = 0) => ({
  initial: { opacity: 0, y: 26 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
  transition: { duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] },
});

function NossosValores() {
  const { t, i18n } = useTranslation();
  const lang = i18n.language?.slice(0, 2) || 'pt';

  const valores = [
    {
      Icon: FaMagnifyingGlass,
      title: t('valores.v1'),
      desc: t('valores.v1Desc'),
    },
    {
      Icon: FaLightbulb,
      title: t('valores.v2'),
      desc: t('valores.v2Desc'),
    },
    {
      Icon: FaHandshake,
      title: t('valores.v3'),
      desc: t('valores.v3Desc'),
    },
    {
      Icon: FaShield,
      title: t('valores.v4'),
      desc: t('valores.v4Desc'),
    },
    {
      Icon: FaStar,
      title: t('valores.v5'),
      desc: t('valores.v5Desc'),
    },
    {
      Icon: FaSeedling,
      title: t('valores.v6'),
      desc: t('valores.v6Desc'),
    },
  ];

  const pratica = [
    {
      n: '01',
      title: t('valores.p1'),
      desc: t('valores.p1Desc'),
    },
    {
      n: '02',
      title: t('valores.p2'),
      desc: t('valores.p2Desc'),
    },
    {
      n: '03',
      title: t('valores.p3'),
      desc: t('valores.p3Desc'),
    },
    {
      n: '04',
      title: t('valores.p4'),
      desc: t('valores.p4Desc'),
    },
  ];

  return (
    <>
      <PageSEO
        title="Nossos Valores"
        description="Transparência, inovação, colaboração, confiabilidade, excelência e adaptabilidade: os valores que guiam cada projeto e relacionamento da SteinSoft."
        path="/NossosValores"
        lang={lang}
      />
      <div className={styles.particles}>
        <ParticlesBackground />
      </div>

      <div className={styles.page}>

        {/* ── Hero ── */}
        <section className={styles.hero}>
          <motion.span className={styles.eyebrow} {...reveal()}>
            {t('valores.eyebrow')}
          </motion.span>
          <motion.h1 className={styles.heroTitle} {...reveal(0.1)}>
            {t('valores.tituloBase')} <span className={styles.accent}>{t('valores.tituloAcc')}</span>
          </motion.h1>
          <motion.p className={styles.heroSub} {...reveal(0.2)}>
            {t('valores.subtitulo')}
          </motion.p>
        </section>

        {/* ── Valores ── */}
        <section className={styles.section}>
          <div className={styles.grid}>
            {valores.map((v, i) => (
              <motion.div key={i} className={styles.card} {...reveal(i * 0.08)}>
                <div className={styles.iconWrap}>
                  <v.Icon />
                </div>
                <h3 className={styles.cardTitle}>{v.title}</h3>
                <p className={styles.cardDesc}>{v.desc}</p>
              </motion.div>
            ))}
          </div>
        </section>

        {/* ── Em Prática ── */}
        <section className={styles.section}>
          <motion.h2 className={styles.sectionTitle} {...reveal()}>
            {t('valores.praticaTituloBase')} <span className={styles.accent}>{t('valores.praticaTituloAcc')}</span>
          </motion.h2>
          <div className={styles.praticaList}>
            {pratica.map((p, i) => (
              <motion.div key={i} className={styles.praticaItem} {...reveal(i * 0.1)}>
                <span className={styles.praticaNum}>{p.n}</span>
                <div className={styles.praticaContent}>
                  <h3 className={styles.praticaTitle}>{p.title}</h3>
                  <p className={styles.praticaDesc}>{p.desc}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </section>

        {/* ── Quote ── */}
        <motion.section className={styles.quoteSection} {...reveal(0.1)}>
          <div className={styles.quoteBox}>
            <span className={styles.quoteMark}>"</span>
            <p className={styles.quoteText}>
              {t('valores.quote')}
            </p>
            <span className={styles.quoteAuthor}>{t('valores.quoteAutor')}</span>
          </div>
        </motion.section>

      </div>
    </>
  );
}

export default NossosValores;
